import { useMemo } from 'react';
import { useAuth } from '@/context/AuthContext';

const LEADER_ROLES = ['org_admin', 'campus_pastor', 'ministry_director', 'group_leader'];

/**
 * Leader status resolved from the org that OWNS the given group. The global
 * `useAuth().role` tracks the current org, which lags/differs while viewing
 * a cross-org group from a rail — never use it for per-group leader gating.
 * The backend enforces real permissions on every leader endpoint, so UI
 * over-showing degrades to a 403 toast, never a security hole.
 */
export function useGroupLeadership(groupId: string | null | undefined): boolean {
  const { organizations } = useAuth();
  return useMemo(() => {
    if (!groupId) return false;
    const membership = organizations.find((o) => o.groups?.some((g) => g.id === groupId));
    return Boolean(membership?.roles.some((r) => LEADER_ROLES.includes(r.role)));
  }, [organizations, groupId]);
}
